import { isFormArrayFieldsEqual } from '../../../utils/formHelpers'
import {
  EntityActionTypeSelectOptionValue,
  getEntityActionTypeSelectOptions,
} from '../../Entity'
import { formValidationSchemaNoChanged } from '../../Form'
import { FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME } from '../../Formik'

import {
  USER_EDIT_CATEGORIES_MODAL_EMPTY_VALUES,
  USER_EDIT_CATEGORIES_MODAL_FIELD_NAME_CATEGORIES,
} from './UserEditCategoriesModal.constants'

export function getUserEditCategoriesModalActionTypes() {
  const actionTypeOptions = getEntityActionTypeSelectOptions()

  return [
    actionTypeOptions[EntityActionTypeSelectOptionValue.Edit],
    actionTypeOptions[EntityActionTypeSelectOptionValue.RemoveAll],
  ]
}

export function getUserEditCategoriesModalInitialValues(categories) {
  const actionTypeOptions = getEntityActionTypeSelectOptions()

  return {
    ...USER_EDIT_CATEGORIES_MODAL_EMPTY_VALUES,
    [FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME]:
      actionTypeOptions[EntityActionTypeSelectOptionValue.Edit],
    [USER_EDIT_CATEGORIES_MODAL_FIELD_NAME_CATEGORIES]: categories,
  }
}

export function getUserEditCategoriesModalValidationSchema(initialValues) {
  return formValidationSchemaNoChanged({
    initialValues,
    isEqual: isFormArrayFieldsEqual,
    isEqualProps: {
      name: USER_EDIT_CATEGORIES_MODAL_FIELD_NAME_CATEGORIES,
    },
  })
}
